
        import 'Slider.d33174e.css-module'
        export default {"Slider":"Slider_Slider_d33174e"}
    